var map = {
	"./COIN2.png": 5007,
	"./Delete.png": 4427,
	"./Ellipse 1.png": 4295,
	"./Frame_40117.png": 3287,
	"./Screenshot_1.png": 3122,
	"./Vector.png": 475,
	"./Vector1.png": 3482,
	"./Vector3.png": 7848,
	"./accordian_icon.png": 9698,
	"./account_icon1.png": 8984,
	"./account_icon2.png": 3475,
	"./account_icon3.png": 2714,
	"./account_icon4.png": 7381,
	"./app_login_icon.png": 7067,
	"./applestore.png": 8005,
	"./arrow_orange.png": 114,
	"./aunthentication.png": 5066,
	"./auth_back.png": 1500,
	"./auth_img_01.png": 8768,
	"./auth_img_02.png": 3803,
	"./auth_img_03.png": 4802,
	"./banner-blog.png": 6975,
	"./bg_auth.png": 6762,
	"./bitcoin.png": 8934,
	"./blue.png": 7246,
	"./box-hover.png": 5914,
	"./btc.png": 389,
	"./btc1.png": 8504,
	"./btn-arrow-1.png": 8034,
	"./btn-arrow.png": 1452,
	"./card_bg.png": 7216,
	"./card_bg_1.png": 8872,
	"./chart_01.png": 1440,
	"./chart_02.png": 1291,
	"./close-btn.png": 4527,
	"./close-btn1.png": 614,
	"./coin1.png": 4132,
	"./coni3.png": 6504,
	"./copy-Filled.png": 6368,
	"./darklogo.png": 5207,
	"./dash_bg.png": 4210,
	"./desktop_login_icon (1).png": 4538,
	"./desktop_login_icon (2).png": 8091,
	"./desktop_login_icon.png": 5000,
	"./down_arrow.png": 3928,
	"./downtrend_icon.png": 8253,
	"./error.png": 5586,
	"./eth.png": 9897,
	"./eth1.png": 1604,
	"./file_upload.png": 5490,
	"./flag.png": 1356,
	"./green.png": 77,
	"./icon1.png": 8408,
	"./icon2.png": 5267,
	"./icon3.png": 3690,
	"./icon4.png": 7989,
	"./icon5.png": 5100,
	"./img1.png": 6888,
	"./img2.png": 2163,
	"./img3.png": 4586,
	"./img4.png": 1093,
	"./img5.png": 1996,
	"./img6.png": 2055,
	"./key.png": 4157,
	"./login_bg.png": 6721,
	"./login_img.png": 647,
	"./logpage.png": 7507,
	"./mail.png": 2967,
	"./menu_icons/menu_icon_01.png": 586,
	"./menu_icons/menu_icon_02.png": 9569,
	"./menu_icons/menu_icon_03.png": 1304,
	"./menu_icons/menu_icon_04.png": 6471,
	"./menu_icons/menu_icon_05.png": 3454,
	"./menu_icons/menu_icon_06.png": 5253,
	"./menu_icons/menu_icon_07.png": 5836,
	"./menu_icons/menu_icon_08.png": 9435,
	"./menu_icons/menu_icon_09.png": 8306,
	"./menu_icons/menu_icon_10.png": 264,
	"./menu_icons/menu_icon_11.png": 209,
	"./model-img.png": 1249,
	"./model_bg.png": 1369,
	"./news_01.png": 4925,
	"./news_02.png": 3158,
	"./news_03.png": 6959,
	"./notification.png": 8015,
	"./phone.png": 8072,
	"./playstore.png": 1949,
	"./profile1.png": 5686,
	"./profile2.png": 6893,
	"./profile3.png": 5764,
	"./profile4.png": 5675,
	"./qr_code.png": 4323,
	"./responsive-bg.png": 6854,
	"./scan_icon.png": 1985,
	"./sec-ban.png": 539,
	"./sec1-before.png": 2704,
	"./sec3-ban.png": 7400,
	"./sec6-ban.png": 7765,
	"./select.png": 2706,
	"./supportempty.png": 7522,
	"./tick.png": 9461,
	"./ticket.png": 258,
	"./trade-track-down.png": 3191,
	"./trade-track.png": 692,
	"./trade.png": 1558,
	"./uptrend_icon.png": 8374,
	"./usdc.png": 3445,
	"./usdc1.png": 9288,
	"./usdcimg.png": 8152,
	"./userImage.png": 804,
	"./userdetail.png": 1016,
	"./verified.png": 2886,
	"./white-btn-arrow.png": 9372
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;